import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMoreHorizontal(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm5-2a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm7 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
